import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { gql } from "../../utils/gqlClient";
import { wrapQuery } from "../../utils/wrapQuery";
export { ssoSignup, ssoAuthTokens };
var ssoSignupMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation SsoSignup(\n    $ssoUserCredentials: SsoUserCredentials!\n    $userDetails: SsoUserDetails\n    $userProfile: UserProfile!\n    $clientId: String!\n  ) {\n    signUpSsoUser(\n      ssoUserCredentials: $ssoUserCredentials\n      userDetails: $userDetails\n      userProfile: $userProfile\n      clientId: $clientId\n    ) {\n      tokens {\n        idToken\n        accessToken\n        expires\n      }\n      encryptedCheggId\n      encryptedEmail\n      uuid\n    }\n  }\n"])));
var ssoAuthTokensMutation = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  mutation SsoAuthTokens($ssoUserCredentials: SsoUserCredentials!, $clientId: String!) {\n    ssoAuthTokens(ssoUserCredentials: $ssoUserCredentials, clientId: $clientId) {\n      userCreated\n      tokens {\n        idToken\n        accessToken\n        expires\n      }\n      encryptedCheggId\n      encryptedEmail\n      uuid\n    }\n  }\n"])));
async function ssoSignup(ssoUserCredentials, userDetails, userProfile, clientId) {
  var data = await wrapQuery('ssoSignup', ssoSignupMutation, {
    ssoUserCredentials: ssoUserCredentials,
    userDetails: userDetails,
    userProfile: userProfile,
    clientId: clientId
  });
  return data.signUpSsoUser;
}
async function ssoAuthTokens(ssoUserCredentials, clientId) {
  var data = await wrapQuery('ssoAuthTokens', ssoAuthTokensMutation, {
    ssoUserCredentials: ssoUserCredentials,
    clientId: clientId
  });
  return data.ssoAuthTokens;
}